export default __webpack_public_path__ + "static/media/placeholder_dummy2016-sprachunterricht01-de.6c11aede.png";